import TypeCard from "./TypeCard/TypeCard"; // ← your existing TypeCard

import "./styles.scss";

export default function AllDetailsSidebar({
  className,
  sections = [],
  selectedItem,
  onSelect,
  activeTitle,
  onActiveChange,
  actionButton,
  backdrop,
}) {
  const handleSetActive = (title) => {
    onActiveChange?.(title);
  };

  const handleSelect = (item) => {
    onSelect?.(item);
  };

  return (
    <div className={className ?? "expandable-sidebar"}>
      {actionButton && (
        <button
          type="button"
          className={actionButton.className ?? "thunter-additional-data__sidebar__download"}
          onClick={actionButton.onClick}>
          {actionButton.label} {actionButton.icon || null}
        </button>
      )}

      {sections.map(({ id, title, items, titleKeyword }) => (
        <TypeCard
          key={id}
          itemArray={items}
          itemTitleKeyword={titleKeyword}
          onClick={handleSetActive}
          active={activeTitle}
          selectedFile={selectedItem}
          setSelectedFile={handleSelect}
          title={title}
        />
      ))}

      {backdrop?.show ? backdrop.node : null}
    </div>
  );
}
